import * as React from 'react';

export const onImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img: HTMLImageElement = (e.target as HTMLImageElement);
    img.onerror = () => {};
    img.style.visibility = 'hidden';
};
